import "../assets/common5.css";
import { d as t } from "./defined-by-default.11c0fbdd.js";
import { c as i } from "./index.bddf5ebb.js";
const c = "_link_53vzy_1", o = "_label_53vzy_31", d = "_small_53vzy_51", r = "_large_53vzy_58", m = "_black_53vzy_65", y = "_subtle_53vzy_69", g = "_white_53vzy_73", h = "_hideUnderline_53vzy_77", b = "_leadingIcon_53vzy_81", l = {
  link: c,
  label: o,
  "extra-small": "_extra-small_53vzy_44",
  small: d,
  large: r,
  black: m,
  subtle: y,
  white: g,
  hideUnderline: h,
  leadingIcon: b
}, u = ({
  className: _,
  hasUnderline: s,
  iconPosition: a,
  size: e,
  variant: n
}) => i([l.link, _], {
  [l[e || ""]]: e !== "medium",
  [l[n || ""]]: n !== "highlight",
  [l.hideUnderline]: !t(s),
  [l.leadingIcon]: a === "leading"
});
export {
  u as c,
  l as s
};
//# sourceMappingURL=common.e2f986a6.js.map
